module.exports = __webpack_public_path__ + "static/img/phone-head.a1f1bc80.png";